import React from 'react';
import FlowSheetWizardv1 from './flowSheetWizard';

const FlowSheetWizard = () => {
  return (
    <div>
      <FlowSheetWizardv1 />
    </div>
  );
};
export default FlowSheetWizard;